/* global Sys, NetEntExtend */
Sys.ns("NetEntExtend.API");

/**
 * A getter for NetEnt Extend with the basic functionality.
 *
 * @class NetEntExtend.API.BaseGetter
 */
NetEntExtend.API.BaseGetter = {
    platforms: ["desktop", "mobile"],
    isAvailable: function() {
        return true;
    },
    validateNumArguments: function() {
        return arguments.length === 3;
    },
    validateArguments: function() {
        return true;
    },
    func: function() {
        // stub
    }
};
